<template>

  <section class="theme-bg feature" id="feature" ref="featurePosition">
    <div class="container">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-title">
            <h2 class="text-white">Chat Loop Feature</h2>
            <img
              src="../assets/images/white-line.png"
              alt="white-line"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-4 col-sm-6">
          <div class="future-box">
            <div class="future-timeline">
              <ul>
                <li class="timeline">
                  <h4 class="sub-title">Easy Installation</h4>
                  <p class="">Lorem Ipsum has been the industry's</p>
                </li>
                <li class="timeline">
                  <h4 class="sub-title">Multi Platform Chat App</h4>
                  <p class="">Lorem Ipsum has been the industry's</p>
                </li>
                <li class="timeline">
                  <h4 class="sub-title">Secure Backup & Recovery</h4>
                  <p class="">Many desktop publishing packages</p>
                </li>
                <li class="timeline">
                  <h4 class="sub-title">Easy File Sharing</h4>
                  <p class="">Lorem Ipsum has been the industry's</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4 future-mobile">
          <img
            src="../assets/images/feature-mob.png"
            alt="feature-mob"
            class="img-fluid"
          />
        </div>
        <div class="col-lg-4 col-sm-6">
          <div class="future-box">
            <div class="future-timeline-right">
              <ul class="text-left">
                <li class="timeline-right">
                  <h4>Easy Installation</h4>
                  <p class="">Lorem Ipsum has been the industry's</p>
                </li>
                <li class="timeline-right">
                  <h4>Multi Platform Chat App</h4>
                  <p class="">Lorem Ipsum has been the industry's</p>
                </li>
                <li class="timeline-right">
                  <h4>Secure Backup & Recovery</h4>
                  <p class="">Many desktop publishing packages</p>
                </li>
                <li class="timeline-right">
                  <h4>Easy File Sharing</h4>
                  <p class="">Lorem Ipsum has been the industry's</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<script>
export default {
  name: "Feature",
  mounted() {
    let payload = {
      position: this.$refs["featurePosition"].offsetTop,
      name: "featurePosition",
    };
    this.$emit("windowPosition", payload);
  },
};
</script>
